import React, { useState } from 'react';
import { TextField, Button, Grid, Paper } from '@mui/material';

export interface MortgageFormProps {
  onCalculate: (mortgageData: MortgageData) => void;
}

export interface MortgageData {
  housePrice: number;
  downPayment: number;
  annualInterestRate: number;
  loanTerm: number; // en años
}

const MortgageForm: React.FC<MortgageFormProps> = ({ onCalculate }) => {
  const [housePrice, setHousePrice] = useState(400000);
  const [downPayment, setDownPayment] = useState(150000);
  const [annualInterestRate, setAnnualInterestRate] = useState(3);
  const [loanTerm, setLoanTerm] = useState(30);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onCalculate({
      housePrice,
      downPayment,
      annualInterestRate,
      loanTerm,
    });
  };

  return (
    <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Coste de la vivienda"
              type="number"
              fullWidth
              value={housePrice}
              onChange={(e) => setHousePrice(parseFloat(e.target.value))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Entrada"
              type="number"
              fullWidth
              value={downPayment}
              onChange={(e) => setDownPayment(parseFloat(e.target.value))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Tipo de interés TAE (%)"
              type="number"
              fullWidth
              value={annualInterestRate}
              onChange={(e) => setAnnualInterestRate(parseFloat(e.target.value))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Plazo del préstamo (años)"
              type="number"
              fullWidth
              value={loanTerm}
              onChange={(e) => setLoanTerm(parseInt(e.target.value))}
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" type="submit" fullWidth>
              Calcular
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default MortgageForm;
